import axios from 'axios';
const lastBarsCache = new Map();

export default {
	onReady: async (callback) => {
		const res = await axios.get(`${process?.env?.REACT_APP_URL_TRADINGVIEW}/config`)
		setTimeout(() => callback(res?.data));
	},

	searchSymbols: async (
		userInput,
		exchange,
		symbolType,
		onResultReadyCallback,
	) => {
		const res = await axios.get(`${process?.env?.REACT_APP_URL_TRADINGVIEW}/search?query=${userInput.toUpperCase()}&limit=10&exchange=${exchange}`)
		// dispatch(changeInputSearchStock({ value: userInput.toUpperCase(), loading: true }))
		onResultReadyCallback(res?.data);
	},

	resolveSymbol: async (
		symbolName,
		onSymbolResolvedCallback,
		onResolveErrorCallback,
	) => {
		const res = await axios.get(`${process?.env?.REACT_APP_URL_TRADINGVIEW}/symbols?symbol=${symbolName.toUpperCase()}`)
		const symbolItem = res?.data
		if (!symbolItem) {
			onResolveErrorCallback('cannot resolve symbol');
			return;
		}
		const symbolInfo = {
			ticker: symbolItem.full_name,
			name: symbolItem.symbol,
			description: symbolItem.description,
			type: symbolItem.type,
			session: '24x7',
			timezone: 'Asia/Bangkok',
			exchange: symbolItem.exchange,
			minmov: 1,
			pricescale: 100,
			has_intraday: false,
			has_no_volume: false,
			has_weekly_and_monthly: false,
			supported_resolutions: ['1D', '1W', '1M'],
			volume_precision: 2,
			data_status: 'streaming',
		};

		onSymbolResolvedCallback(symbolInfo);
	},

	getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback,) => {
		const { from, to, countBack, firstDataRequest } = periodParams;
		try {
			const res = await axios.get(`${process?.env?.REACT_APP_URL_TRADINGVIEW}/history?
			symbol=${symbolInfo?.ticker.toUpperCase()}&resolution=D&from=${0}&to=${to}&countback=${countBack}`)
			if (res.status && res.status !== 200 || res.data?.t.length === 0) {
				onHistoryCallback([], {
					noData: true,
				});
				return;
			}
			let bars = [];
			res?.data?.t.map((item, key) => {
				if (item >= from && item < to) {
					bars = [...bars, {
						time: res?.data?.t?.[key] * 1000,
						low: res?.data?.l?.[key] ? parseFloat(res?.data?.l?.[key]) : 0,
						high: res?.data?.h?.[key] ? parseFloat(res?.data?.h?.[key]) : 0,
						open: res?.data?.o?.[key] ? parseFloat(res?.data?.o?.[key]) : 0,
						close: res?.data?.c?.[key] ? parseFloat(res?.data?.c?.[key]) : 0,
						volume: res?.data?.v?.[key] ? parseFloat(res?.data?.v?.[key]) : 0,
					}];
				}
			});
			if (firstDataRequest) {
				lastBarsCache.set(symbolInfo.full_name, {
					...bars[bars.length - 1],
				});
			}
			onHistoryCallback(bars, {
				noData: false,
			});
		} catch (error) {
			onErrorCallback(error);
		}
	},

	subscribeBars: (
		symbolInfo,
		resolution,
		onRealtimeCallback,
		subscribeUID,
		onResetCacheNeededCallback,
	) => {
		// subscribeOnStream(
		// 	symbolInfo,
		// 	resolution,
		// 	onRealtimeCallback,
		// 	subscribeUID,
		// 	onResetCacheNeededCallback,
		// 	lastBarsCache.get(symbolInfo.full_name),
		// );
	},

	unsubscribeBars: (subscriberUID) => {
		// unsubscribeFromStream(subscriberUID);
	},
};
